import React from "react";
import { Link } from "react-router-dom";
import PersonalService from '../../assets/house.jpg';

const PerService = () => {
  return (
    <div className="per-service py-12 px-4 sm:px-6 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-col lg:flex-row items-center justify-between gap-8 lg:gap-16">
          {/* Content section */}
          <div className="section-left flex-1 w-full md:order-1 lg:order-1">
            <div className="section-title mb-1">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 leading-tight mb-4">
                Your Path to <span className="text-gray-900">Financial Freedom</span>
              </h2>
              <h3 className="text-lg sm:text-xl text-gray-900 mb-6 font-medium">Building Wealth for Your Dreams</h3>
              <p className="text-gray-900 text-sm sm:text-xl mb-8 leading-relaxed">
                At Senior Vault Capital, we specialize in helping you build capital to achieve your life goals. Whether it's owning a home, starting a business, or securing your future, our proven financial strategies are designed to grow your wealth systematically and help you realize your aspirations.
              </p>
              
              <div className="why-choose-us mb-10">
                <h4 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 border-l-4 border-gray-900 pl-4">Our Capital Growth Approach</h4>
                <p className="text-gray-900 mb-6 text-sm">
                  We create personalized financial roadmaps that align with your unique goals, whether that's home ownership, business investment, or personal wealth building.
                </p>
                
                <div className="features space-y-6 sm:space-y-8">
                  <div className="feature bg-gray-50 p-6 rounded-xl hover:shadow-md transition-shadow duration-300">
                    <h5 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 flex items-center">
                      <svg className="w-5 h-5 text-gray-900 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                      Smart Capital Solutions
                    </h5>
                    <p className="text-gray-900 text-sm">
                      Our strategic investment approaches help grow your funds efficiently, whether you're saving for a home, business, or other major life goals.
                    </p>
                  </div>
                  <div className="feature bg-gray-50 p-6 rounded-xl hover:shadow-md transition-shadow duration-300">
                    <h5 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 flex items-center">
                      <svg className="w-5 h-5 text-gray-900 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      Goal-Oriented Planning
                    </h5>
                    <p className="text-gray-900 text-sm">
                      We create customized plans that map out your financial journey from where you are today to where you want to be tomorrow.
                    </p>
                  </div>
                  <div className="feature bg-gray-50 p-6 rounded-xl hover:shadow-md transition-shadow duration-300">
                    <h5 className="text-md sm:text-xl font-semibold text-gray-900 mb-2 flex items-center">
                      <svg className="w-5 h-5 text-gray-900 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                      </svg>
                      Dream Realization
                    </h5>
                    <p className="text-gray-900 text-sm">
                      From home ownership to business ventures, we provide the financial foundation and guidance to turn your aspirations into reality.
                    </p>
                  </div>
                </div>
              </div>
              
              <Link 
                to="/plans" 
                 onClick={() => window.scrollTo(0, 0)}
                className="inline-block bg-gradient-to-r from-gray-900 to-black text-white px-4 sm:px-10 py-3 sm:py-4 rounded-lg font-medium hover:from-black hover:to-gray-900 transition duration-300 text-sm shadow-lg hover:shadow-xl"
              >
                Investment plans
                <svg className="w-4 h-4 ml-2 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Image section */}
          <div className="section-right flex-1 w-full md:max-w-[80%] lg:max-w-none md:order-2 lg:order-2">
            <div className="relative overflow-hidden rounded-md shadow-2xl">
              <img
                src={PersonalService}
                alt="Happy family achieving their dreams"
                className="w-full h-auto object-cover min-h-[250px] sm:min-h-[350px] md:min-h-[300px] lg:min-h-[500px]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900/10 to-black/10"></div>
              <div className="absolute bottom-6 left-6 right-6 bg-white/60 p-2 sm:p-2 md:p-4 lg:p-4 rounded-lg shadow-lg">
                <h4 className="text-sm font-bold text-gray-900">"Senior Vault Capital helped us grow our capital to achieve both our business and home ownership goals!"</h4>
                <p className="text-gray-800 mt-2">- The Johnson Family</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerService;